import {StyleSheet} from 'react-native';
import CommonStyles from '../../../utils/CommonStyles';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    inputContainer: {
      ...CommonStyles.flex_row,
      ...CommonStyles.mt_32,
    },
    leftInput: {
      ...CommonStyles.full_flex,
      ...CommonStyles.max_width_292,
      ...CommonStyles.mr_16,
    },
    rightInput: {
      ...CommonStyles.full_flex,
      ...CommonStyles.max_width_292,
      ...CommonStyles.ml_16,
    },
  });

export default makeStyles;
